import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from '@/store'

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";

import Swal from 'sweetalert2'
import baseApi from '@/baseApi'
import VModal from 'vue-js-modal'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import { PaperTable } from "@/components";
import SimplePagination from '@/components/Simple-pagination.vue';
import TableInfo from '@/components/Table-info.vue';
import DeleteButton from '@/components/DeleteButton.vue';
import CreateButton from '@/components/CreateButton.vue';
import EditButton from '@/components/EditButton.vue';
import UpdateButton from '@/components/UpdateButton.vue';
import StoreButton from '@/components/StoreButton.vue';
import ShowButton from '@/components/ShowButton.vue';
import BackButton from '@/components/BackButton.vue';
import DropdownActions from '@/components/DropdownActions.vue';
import SearchButton from '@/components/SearchButton.vue';
import TheSearchResult from '@/components/TheSearchResult.vue';
import excel from 'vue-excel-export'
import vSelect from 'vue-select'
import VueHtmlToPaper from 'vue-html-to-paper';
import VueApexCharts from 'vue-apexcharts'
import VueCookies from 'vue-cookies'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.use(PaperDashboard);
Vue.use(VModal)
Vue.use(VueToast);
Vue.use(require('vue-moment'));
Vue.use(VueCookies, { expires: '7d'})

// Vue.filter('formatDate', function(value) {
//   if (value) {
//       return moment(String(value)).format('MM/DD/YYYY hh:mm')
//   }
// });
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  autoClose: false,
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    '<style>body{dir:rtl !important;}</style>',

  ]
}

Vue.use(VueHtmlToPaper, options);

//global components
Vue.component('paper-table', PaperTable);
Vue.component('simple-pagination', SimplePagination);
Vue.component('table-info', TableInfo);
Vue.component('delete-button', DeleteButton);
Vue.component('create-button', CreateButton);
Vue.component('edit-button', EditButton);
Vue.component('update-button', UpdateButton);
Vue.component('store-button', StoreButton);
Vue.component('show-button', ShowButton);
Vue.component('back-button', BackButton);
Vue.component('dropdown-actions', DropdownActions);
Vue.component('search-button', SearchButton);
Vue.component('search-result', TheSearchResult);

Vue.component('v-select', vSelect)

//global Variables
Vue.prototype.$baseApi = baseApi();

/* eslint-disable no-new */
const app = new Vue({
  router,
  data: {isLoading: false, swal: Swal, langs: {}, trans: {}},
  render: h => h(App),
  store: store,
  beforeCreate() { this.$store.commit('initialiseStore');}
}).$mount("#app");

let timeout = '';
router.beforeEach((to, from, next) => {
  //clearTimeout(timeout);
  app.isLoading = true;
  next();
});


const Toast = Swal.mixin({

})
Vue.use(excel)
Vue.mixin({
  methods: {
    hasPermissions: function (permission) {
      const permissions = store.getters.GET_PERMISSIONS;
      const user = store.getters.SET_AUTH_USER;
      return user.id == 1 ? true : (user.permissions ? user.permissions.includes(permission) : false);
    },
    weightFormat: function (weight) {
      const trans = store.getters.GET_TRANS;
      return weight + ' ' + trans.global.weight;

    },
    moneyFormat: function (money, curr) {
      const currencies = store.getters.GET_CURRENCIES;
      const currency   = store.getters.GET_CURRENCY;
      let form         = curr ? curr : currency;
      return money + ' ' + currencies[form];
    },
    print_element(element_id, page_title) {
      var custom_styles = [
          'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
          'https://unpkg.com/kidlat-css/css/kidlat.css',
          'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css'

      ];
      var custom_style_codes = ""
      for (var i = 0; i < custom_styles.length; i++) {
        custom_style_codes += `<link href="${custom_styles[i]}" rel="stylesheet"/>`
      }
      var element_html = document.getElementById(element_id).innerHTML
      var html_code = `
            <html dir="rtl">
                <head>
                  <title>${page_title}</title>
                    ${custom_style_codes}
                    <style>
                    @media print {
                      .printOnly {
                         display : block;
                      }
                  }
                    </style>
            
</head>
<body scroll class="scroll-overlay-y page-loading">
<section class="application-form py-5">

    <div class="container">

      <div class="row" id="custom-font">
${element_html}
</div>
</div>
</<section>
                </body>
            </html>
        `

      var printer_win = window.open('', 'Print-Window')
      printer_win.document.write(html_code)
      printer_win.document.close()
      printer_win.focus()
      setTimeout( () => {
        printer_win.print()
        printer_win.close()
      }, 3000)
    },
    sweetAlert(message = 'please enter any message', type = 'success') {
      this.$root.swal.fire({
        icon: type,
        text: message,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
    },
    flashAlert(message = 'العملية تمت بنجاح', type = 'success', key = 'flash_message'){
      if(localStorage.getItem(key)){
        let msg = localStorage.getItem('flash_message') ? localStorage.getItem('flash_message') : message;
        this.sweetAlert(msg, type)
        localStorage.removeItem(key);
      }
    }
  },
})



router.afterEach((to, from, next) => {
  app.isLoading = true;
  let locale = localStorage.getItem('locale');
  if (!locale) {
    locale = 'ar';
  }
  setTimeout(() => {
  app.isLoading = false;
    
  }, 2000);
});
